import { normalizeCollectionResponse, normalizeRecordResponse, priceParams } from 'api';
import { client } from 'queries';

export const priceQuery = async ({ req, params }) => {
	const response = await client.apiRequest({ url: `/prices/${params.priceId}`, params: priceParams });
	return normalizeRecordResponse(response);
};

export const pricesQuery = async ({ req, params, query }) => {
	const response = await client.apiRequest({
		url: `/prices`,
		params: { ...priceParams, interval: query?.interval || 'year' },
	});
	return normalizeCollectionResponse(response);
};
